import { render, staticRenderFns } from "./TutorLoginIcon.vue?vue&type=template&id=36c0c6c5&"
import script from "./TutorLoginIcon.vue?vue&type=script&lang=js&"
export * from "./TutorLoginIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports